import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'yBro';
const SITE_URL = 'https://ybro.com';
const DEFAULT_DESCRIPTION =
  'Expert GBP Management, Review Handling, Local SEO, Ad Campaigns & DMCC Act Compliance for businesses worldwide.';
const DEFAULT_IMAGE = `${SITE_URL}/og-ybro-new.png`;

export default function Seo({ title, description, path = '/', image }) {
  const metaTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = `${SITE_URL}${path}`;
  const metaImage = image || DEFAULT_IMAGE;

  useEffect(() => {
    document.title = metaTitle;

    const upsertMeta = (selector, attrs, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        Object.entries(attrs).forEach(([key, value]) => {
          element.setAttribute(key, value);
        });
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    upsertMeta('meta[property="og:title"]', { property: 'og:title' }, metaTitle);
    upsertMeta('meta[property="og:description"]', { property: 'og:description' }, metaDescription);
    upsertMeta('meta[property="og:url"]', { property: 'og:url' }, canonicalUrl);
    upsertMeta('meta[property="og:image"]', { property: 'og:image' }, metaImage);
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, metaTitle);
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, metaDescription);
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, metaImage);
  }, [metaTitle, metaDescription, canonicalUrl, metaImage]);

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={metaImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
}
